const topbar = {
    docs: 'ドキュメント',
    help: 'ヘルプ',
    /** UNTRANSLATED */
    subscription: 'Subscription',
};
export default Object.freeze(topbar);
